export const CHECKOUT_BASE_PATH = '/checkout';
export const CHECKOUT_QUEST_BASE_PATH = '/quest-checkout';
